import { makeDataState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  contest: makeDataState(),
  contestEvent: makeDataState(),
  contestRanking: makeDataState(),
  contestStory: makeDataState(),
  myContestStory: makeDataState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_CONTEST}_SUCCESS`:
      return {
        ...state,
        contest: {
          ...state.contest,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_CONTEST_EVENT}_SUCCESS`:
      return {
        ...state,
        contestEvent: {
          ...state.contestEvent,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_CONTEST_COMPLETE}_SUCCESS`:
      return {
        ...state,
        contestEvent: {
          ...state.contestEvent,
          data: {
            ...state.contestEvent.data,
            join: {
              ...state.contestEvent.data.join,
              status: 'RECEIVED',
            },
          },
        },
      };

    case `${t.FETCH_CONTEST_MY_STORY}_SUCCESS`:
      return {
        ...state,
        myContestStory: {
          ...state.contestStory,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_CONTEST_STORY}_SUCCESS`:
      return {
        ...state,
        contestStory: {
          ...state.contestStory,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    case `${t.POST_CONTEST_STORY_VOTE}_SUCCESS`:
      return {
        ...state,
        contestStory: {
          ...state.contestStory,
          data: {
            ...state.contestStory.data,
            isVoted: true,
          },
        },
      };

    case `${t.FETCH_CONTEST_RANKING}_SUCCESS`:
      return {
        ...state,
        contestRanking: {
          ...state.contestRanking,
          isLoaded: true,
          status: STATUSES.SUCCESS,
          data: action.payload.result,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/events/contest/reducer.js